// // import React, { useState } from 'react';
// // import { Link } from 'react-router-dom';
// // import { 
// //   Home, Settings, Users, BarChart, Calendar, NotebookPen, Bed, Receipt, UserPlus, Truck, FileText 
// // } from 'lucide-react';

// // const Navbar = () => {
// //   const [isDashboardOpen, setIsDashboardOpen] = useState(false);
// //   const [isStaffOpen, setIsStaffOpen] = useState(false);
// //   const [isRoomOpen, setIsRoomOpen] = useState(false);
// //   const [isRecordOpen, setIsRecordOpen] = useState(false);
// //   const [isAmbulanceOpen, setIsAmbulanceOpen] = useState(false);

// //   return (
// //     <nav className="bg-gray-800 text-white p-4 w-64 min-h-screen">+
// //       <ul className="space-y-2">
        
// //         {/* Dashboard */}
// //         <li>
// //           <button className="flex items-center gap-2 w-full text-left p-2 hover:bg-gray-700 rounded-md"
// //             onClick={() => setIsDashboardOpen(!isDashboardOpen)}
// //           >
// //             <Home />
// //             <span>Dashboard</span>
// //           </button>
// //           {isDashboardOpen && (
// //             <ul className="ml-6 mt-2 space-y-2">
// //               <li><Link to="/home/dashboard/admin_dashboard">Admin Dashboard</Link></li>
// //               <li><Link to="/home/dashboard/doctor_dashboard">Doctor Dashboard</Link></li>
// //               <li><Link to="/home/dashboard/patient_dashboard">Patient Dashboard</Link></li>
// //             </ul>
// //           )}
// //         </li>

// //         {/* Staff */}
// //         <li>
// //           <button className="flex items-center gap-2 w-full text-left p-2 hover:bg-gray-700 rounded-md"
// //             onClick={() => setIsStaffOpen(!isStaffOpen)}
// //           >
// //             <Users />
// //             <span>Staff</span>
// //           </button>
// //           {isStaffOpen && (
// //             <ul className="ml-6 mt-2 space-y-2">
// //               <li><Link to="/home/staff/all_staff">All Staff</Link></li>
// //               <li><Link to="/home/staff/add_staff">Add Staff</Link></li>
// //               <li><Link to="/home/staff/edit_staff">Edit Staff</Link></li>
// //               <li><Link to="/home/staff/staff_profile">Staff Profile</Link></li>
// //             </ul>
// //           )}
// //         </li>

// //         {/* Reports */}
// //         <li><Link to="/home/reports" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><BarChart /> Reports</Link></li>

// //         {/* Settings */}
// //         <li><Link to="/home/settings" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><Settings /> Settings</Link></li>

// //         {/* Calendar */}
// //         <li><Link to="/home/calendar" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><Calendar /> Calendar</Link></li>

// //         {/* Register */}
// //         <li><Link to="/home/register" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><NotebookPen /> Register</Link></li>

// //         {/* Room Allotment */}
// //         <li>
// //           <button className="flex items-center gap-2 w-full text-left p-2 hover:bg-gray-700 rounded-md"
// //             onClick={() => setIsRoomOpen(!isRoomOpen)}
// //           >
// //             <Bed />
// //             <span>Room Allotment</span>
// //           </button>
// //           {isRoomOpen && (
// //             <ul className="ml-6 mt-2 space-y-2">
// //               <li><Link to="/home/room_allotment/alloted_rooms">Allotted Rooms</Link></li>
// //               <li><Link to="/home/room_allotment/new_allotment">New Allotment</Link></li>
// //               <li><Link to="/home/room_allotment/edit_allotment">Edit Allocation</Link></li>
// //               <li><Link to="/home/room_allotment/rooms_by_department">Rooms by Department</Link></li>
// //               <li><Link to="/home/room_allotment/add_room">Add Room</Link></li>
// //             </ul>
// //           )}
// //         </li>

// //         {/* Records */}
// //         <li>
// //           <button className="flex items-center gap-2 w-full text-left p-2 hover:bg-gray-700 rounded-md"
// //             onClick={() => setIsRecordOpen(!isRecordOpen)}
// //           >
// //             <Receipt />
// //             <span>Records</span>
// //           </button>
// //           {isRecordOpen && (
// //             <ul className="ml-6 mt-2 space-y-2">
// //               <li><Link to="/home/records/birth_records">Birth Records</Link></li>
// //               <li><Link to="/home/records/death_records">Death Records</Link></li>
// //             </ul>
// //           )}
// //         </li>

// //         {/* Ambulance */}
// //         <li>
// //           <button className="flex items-center gap-2 w-full text-left p-2 hover:bg-gray-700 rounded-md"
// //             onClick={() => setIsAmbulanceOpen(!isAmbulanceOpen)}
// //           >
// //             <Truck />
// //             <span>Ambulance</span>
// //           </button>
// //           {isAmbulanceOpen && (
// //             <ul className="ml-6 mt-2 space-y-2">
// //               <li><Link to="/home/ambulance/ambulance_list">Ambulance List</Link></li>
// //               <li><Link to="/home/ambulance/ambulance_call_list">Ambulance Calls</Link></li>
// //             </ul>
// //           )}
// //         </li>

// //         {/* Pharmacy */}
// //         <li><Link to="/home/pharmacy" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><FileText /> Pharmacy</Link></li>

// //         {/* Blood Bank */}
// //         <li><Link to="/home/blood_bank" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><FileText /> Blood Bank</Link></li>

// //         {/* Accounts */}
// //         <li><Link to="/home/accounts" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><FileText /> Accounts</Link></li>

// //         {/* Departments */}
// //         <li><Link to="/home/departments" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><FileText /> Departments</Link></li>

// //         {/* Inventory */}
// //         <li><Link to="/home/inventory" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><FileText /> Inventory</Link></li>

// //         {/* Human Resources */}
// //         <li><Link to="/home/human_resources" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><FileText /> Human Resources</Link></li>

// //         {/* Insurance */}
// //         <li><Link to="/home/insurance" className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded-md"><FileText /> Insurance</Link></li>

// //       </ul>
// //     </nav>
// //   );
// // };

// // export default Navbar;

// import React, { useState } from 'react';
// import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
// import { Link } from 'react-router-dom';
// import {
//   Home, Settings, Users, BarChart, Calendar, NotebookPen, Bed,
//   Receipt, Truck, FileText
// } from 'lucide-react';


// const AppSidebar = () => {
//   const [collapsed, setCollapsed] = useState(false);
//   const [isClicked, setIsClicked] = useState(false);



//   const toggleSidebar = () => {
//     setCollapsed(!collapsed);
    
//   };



//   const handleClick = () => {
//     setIsClicked(true);
//   };
 
  



//   return (
//     <div style={{ display: 'flex', height: '100vh' }}>
//       <Sidebar collapsed={collapsed}>
//         <Menu>
//           <MenuItem  onClick={toggleSidebar}>{collapsed ? '' : ''}  ☰</MenuItem>
//           {/* <button onClick={toggleSidebar} className="btn btn-light me-3">
//           ☰
//         </button> */}

       
//             <MenuItem component={<Link to="/admin/home" />} 
//             style={{
//         backgroundColor: isClicked ? '#21766f' : 'transparent',
//         borderRadius: isClicked ? '8px' : '0px',
//         color: isClicked ? '#fff' : 'inherit',
//       }}
//        onClick={handleClick}
//       >Admin Dashboard</MenuItem>
           
    

//           <SubMenu label="Appointments" icon={<Calendar size={16} />}>
//             {/* <MenuItem component={<Link to="/admin/home/appointments/appointment_calendar" />}>Appointment Calendar</MenuItem> */}
//             <MenuItem component={<Link to="/admin/home/appointments/view_appointment" />}>View Appointment</MenuItem>
//              {/* <MenuItem component={<Link to="/admin/home/appointments/book_appointment" />}>Book Appointment</MenuItem> */}
//             {/* <MenuItem component={<Link to="/admin/home/appointments/edit_appointment" />}>Edit Appointment</MenuItem> */}
//           </SubMenu>
//           <MenuItem component={<Link to="/admin/home/patients" />} icon={<BarChart size={16} />}>Patients</MenuItem> 
//           <SubMenu label="Staff" icon={<Users size={16} />}>
//             <MenuItem component={<Link to="/admin/home/staff/all_staff" />}>Staff List</MenuItem>
//             {/* <MenuItem component={<Link to="/admin/home/staff/add_staff" />}>Add Staff</MenuItem>
//             <MenuItem component={<Link to="/admin/home/staff/edit_staff" />}>Edit Staff</MenuItem>
//             <MenuItem component={<Link to="/admin/home/staff/staff_profile" />}>Staff Profile</MenuItem> */}
//           </SubMenu>
//           <SubMenu label="Settings" icon={<Users size={16} />}>
//             {/* <MenuItem component={<Link to="/admin/home/staff/all_staff" />}>Settings</MenuItem> */}
//             <MenuItem component={<Link to="/admin/home/doctor_schedule" />} icon={<FileText size={16} />}>Doctor Schedule</MenuItem>
//             <MenuItem component={<Link to="/admin/home/roles" />} icon={<FileText size={16} />}>Roles</MenuItem> 
//             {/* <MenuItem component={<Link to="/home/register" />} icon={<NotebookPen size={16} />}>Register</MenuItem>    */}
//           </SubMenu>
//            {/* <MenuItem component={<Link to="/admin/home/pharmacy" />} icon={<FileText size={16} />}>Pharmacy/Medicine</MenuItem> */}
          
          
//           {/* <MenuItem component={<Link to="/admin/home/reports" />} icon={<BarChart size={16} />}>Reports</MenuItem>  */}
//           {/* <MenuItem component={<Link to="/home/calendar" />} icon={<Calendar size={16} />}>Calendar</MenuItem> */}
         

//           {/* <SubMenu label="Room Allotment" icon={<Bed size={16} />}>
//             <MenuItem component={<Link to="/home/room_allotment/alloted_rooms" />}>Allotted Rooms</MenuItem>
//             <MenuItem component={<Link to="/home/room_allotment/new_allotment" />}>New Allotment</MenuItem>
//             <MenuItem component={<Link to="/home/room_allotment/edit_allotment" />}>Edit Allocation</MenuItem>
//             <MenuItem component={<Link to="/home/room_allotment/rooms_by_department" />}>Rooms by Department</MenuItem>
//             <MenuItem component={<Link to="/home/room_allotment/add_room" />}>Add Room</MenuItem>
//           </SubMenu> */}

//           {/* <SubMenu label="Records" icon={<Receipt size={16} />}>
//             <MenuItem component={<Link to="/home/records/birth_records" />}>Birth Records</MenuItem>
//             <MenuItem component={<Link to="/home/records/death_records" />}>Death Records</MenuItem>
//           </SubMenu> */}

//           {/* <SubMenu label="Ambulance" icon={<Truck size={16} />}>
//             <MenuItem component={<Link to="/home/ambulance/ambulance_list" />}>Ambulance List</MenuItem>
//             <MenuItem component={<Link to="/home/ambulance/ambulance_call_list" />}>Ambulance Calls</MenuItem>
//           </SubMenu> */}

         
//           {/* <MenuItem component={<Link to="/home/blood_bank" />} icon={<FileText size={16} />}>Blood Bank</MenuItem> */}
//           {/* <MenuItem component={<Link to="/home/accounts" />} icon={<FileText size={16} />}>Accounts</MenuItem> */}
//           {/* <MenuItem component={<Link to="/home/departments" />} icon={<FileText size={16} />}>Departments</MenuItem> */}
         
//         <MenuItem component={<Link to="/admin/home/medicines/list"/> } icon={<FileText size={16} />}>Medicine List</MenuItem>

//           <MenuItem component={<Link to="/admin/home/inventory" />} icon={<FileText size={16} />}>Inventory</MenuItem>
//            <MenuItem component={<Link to="/admin/home/human_resources" />} icon={<FileText size={16} />}>Human Resources</MenuItem>
//           {/* <MenuItem component={<Link to="/home/insurance" />} icon={<FileText size={16} />}>Insurance</MenuItem> */}
//         </Menu>

        
//       </Sidebar>
//     </div>
//   );
// };

// export default AppSidebar;







// import React, { useState } from 'react';
// import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
// import { Link,useLocation } from 'react-router-dom';
// import {
//   Home, Settings, Users, BarChart, Calendar, NotebookPen, Bed,
//   Receipt, Truck, FileText
// } from 'lucide-react';
// import 'boxicons/css/boxicons.min.css';

// const AppSidebar = () => {
//   const [collapsed, setCollapsed] = useState(false);
//   const [activeTab, setActiveTab] = useState(''); // NEW: Track active tab

//   const toggleSidebar = () => {
//     setCollapsed(!collapsed);
//   };


//    const location = useLocation();

//   const isActive = (path) => location.pathname === path;

//   // helper to apply active style
//   const getStyle = (tabName) => ({
//     backgroundColor: activeTab === tabName ? '#21766f' : 'transparent',
//     borderRadius: activeTab === tabName ? '50px' : '0px',
//     color: activeTab === tabName ? '#fff' : 'inherit',
//     margin: activeTab === tabName ? '10px' : '0px',
//   });

//   return (
//     <div style={{ display: 'flex', height: '100vh' }}>
//       <Sidebar collapsed={collapsed}>
//         <Menu>
//           <MenuItem onClick={toggleSidebar}>☰</MenuItem>

//           <MenuItem
//             component={<Link to="/admin/home" />}
//             style={getStyle('admin_dashboard')}
//             onClick={() => setActiveTab('admin_dashboard')}
//              icon={<i className="bx bxs-dashboard sidebar-icon" />}
//              className={`sidebar-item ${isActive("/admin/home") ? 'active' : ''}`}
//           >
//             Admin Dashboard
//           </MenuItem>

//           <SubMenu label="Appointments" icon={<Calendar size={16} />}  style={getStyle('appointments')}
//               onClick={() => setActiveTab('appointments')}>
//             <MenuItem
//               component={<Link to="/admin/home/appointments/view_appointment" />}
//               style={getStyle('view_appointment')}
//               onClick={() => setActiveTab('view_appointment')}
//             >
//               View Appointment
//             </MenuItem>
//           </SubMenu>

//           <MenuItem
//             component={<Link to="/admin/home/patients" />}
//             icon={<BarChart size={16} />}
//             style={getStyle('patients')}
//             onClick={() => setActiveTab('patients')}
//           >
//             Patients
//           </MenuItem>

//           <SubMenu label="Staff" icon={<Users size={16} />}  style={getStyle('staff')}
//               onClick={() => setActiveTab('staff')}>
//             <MenuItem
//               component={<Link to="/admin/home/staff/all_staff" />}
//               style={getStyle('all_staff')}
//               onClick={() => setActiveTab('all_staff')}
//             >
//               Staff List
//             </MenuItem>
//           </SubMenu>

//           <SubMenu label="Settings" icon={<Settings size={16} />} 
//               onClick={() => setActiveTab('settings')}
//               style={getStyle('settings')}
//           >
//             <MenuItem
//               component={<Link to="/admin/home/doctor_schedule" />}
//               icon={<FileText size={16} />}
//               style={getStyle('doctor_schedule')}
//               onClick={() => setActiveTab('doctor_schedule')}
//             >
//               Doctor Schedule
//             </MenuItem>

//             <MenuItem
//               component={<Link to="/admin/home/roles" />}
//               icon={<FileText size={16} />}
//               style={getStyle('roles')}
//               onClick={() => setActiveTab('roles')}
//             >
//               Roles
//             </MenuItem>
//           </SubMenu>

//           <MenuItem
//             component={<Link to="/admin/home/medicines/list" />}
//             icon={<FileText size={16} />}
//             style={getStyle('medicine_list')}
//             onClick={() => setActiveTab('medicine_list')}
//           >
//             Medicine List
//           </MenuItem>

//           <MenuItem
//             component={<Link to="/admin/home/inventory" />}
//             icon={<FileText size={16} />}
//             style={getStyle('inventory')}
//             onClick={() => setActiveTab('inventory')}
//           >
//             Inventory
//           </MenuItem>

//           <MenuItem
//             component={<Link to="/admin/home/human_resources" />}
//             icon={<FileText size={16} />}
//             style={getStyle('human_resources')}
//             onClick={() => setActiveTab('human_resources')}
//           >
//             Human Resources
//           </MenuItem>
//         </Menu>
//       </Sidebar>
//     </div>
//   );
// };

// export default AppSidebar;






import React, { useState } from 'react';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, useLocation } from 'react-router-dom';
import 'boxicons/css/boxicons.min.css';

const AppSidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [activeTab, setActiveTab] = useState('');
  const location = useLocation();

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const isActive = (path) => location.pathname === path;

const getStyle = (tabName) => ({
  backgroundColor: activeTab === tabName ? '#21766f' : 'transparent',
  borderRadius: activeTab === tabName ? '50px' : '0px',
  color: activeTab === tabName ? '#fff' : 'inherit',
  margin: activeTab === tabName ? '10px' : '0px',
  paddingTop: activeTab === tabName ? '7px' : '0px',
  paddingBottom: activeTab === tabName ? '7px' : '0px',
  fontWeight: activeTab === tabName ? 'bold' : 'normal', // ✅ fixed
});

  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      <Sidebar collapsed={collapsed}>
        <Menu>
          <MenuItem onClick={toggleSidebar}>☰</MenuItem>

          <MenuItem
            component={<Link to="/admin/home" />}
            style={getStyle('admin_dashboard')}
            onClick={() => setActiveTab('admin_dashboard')}
            icon={<i className="bx bxs-dashboard sidebar-icon" />}
            className={`sidebar-item ${isActive("/admin/home") ? 'active' : ''}`}
          >
            Admin Dashboard
          </MenuItem>

          <SubMenu
            label="Appointments"
            icon={<i className="bx bxs-calendar sidebar-icon" />}
            style={getStyle('appointments')}
            onClick={() => setActiveTab('appointments')}
             className="sidebar-item"

          >
            <MenuItem
              component={<Link to="/admin/home/appointments/view_appointment" />}
              style={getStyle('view_appointment')}
              onClick={() => setActiveTab('view_appointment')}
              icon={<i className="bx bxs-show sidebar-icon" />}
            >
              View Appointment
            </MenuItem>
          </SubMenu>

          <MenuItem
            component={<Link to="/admin/home/patients" />}
            icon={<i className="bx bxs-user-detail sidebar-icon" />}
            style={getStyle('patients')}
            onClick={() => setActiveTab('patients')}
            className={`sidebar-item ${isActive("/admin/home/patients") ? 'active' : ''}`}
          >
            Patients
          </MenuItem>

          <SubMenu
            label="Staff"
            icon={<i className="bx bxs-group sidebar-icon" />}
            style={getStyle('staff')}
            onClick={() => setActiveTab('staff')}
             className="sidebar-item"
          >
            <MenuItem
              component={<Link to="/admin/home/staff/all_staff" />}
              style={getStyle('all_staff')}
              onClick={() => setActiveTab('all_staff')}
              icon={<i className="bx bxs-id-card sidebar-icon" />}
            >
              Staff List
            </MenuItem>
          </SubMenu>

          <SubMenu
            label="Settings"
            icon={<i className="bx bxs-cog sidebar-icon" />}
            onClick={() => setActiveTab('settings')}
            style={getStyle('settings')}
             className="sidebar-item"
          >
            <MenuItem
              component={<Link to="/admin/home/doctor_schedule" />}
              style={getStyle('doctor_schedule')}
              onClick={() => setActiveTab('doctor_schedule')}
              icon={<i className="bx bxs-calendar-check sidebar-icon" />}
            >
              Doctor Schedule
            </MenuItem>

            <MenuItem
              component={<Link to="/admin/home/roles" />}
              style={getStyle('roles')}
              onClick={() => setActiveTab('roles')}
              icon={<i className="bx bxs-user-badge sidebar-icon" />}
            >
              Roles
            </MenuItem>
          </SubMenu>

          <MenuItem
            component={<Link to="/admin/home/medicines/list" />}
            icon={<i className="bx bxs-capsule sidebar-icon" />}
            style={getStyle('medicine_list')}
            onClick={() => setActiveTab('medicine_list')}
              className={`sidebar-item ${isActive("/admin/home/medicines/list") ? 'active' : ''}`}
          >
            Medicine List
          </MenuItem>

          <MenuItem
            component={<Link to="/admin/home/inventory" />}
            icon={<i className="bx bxs-box sidebar-icon" />}
            style={getStyle('inventory')}
            onClick={() => setActiveTab('inventory')}
             className={`sidebar-item ${isActive("/admin/home/inventory") ? 'active' : ''}`}
          >
            Inventory
          </MenuItem>

          <MenuItem
            component={<Link to="/admin/home/human_resources" />}
            icon={<i className="bx bxs-briefcase-alt sidebar-icon" />}
            style={getStyle('human_resources')}
            onClick={() => setActiveTab('human_resources')}
             className={`sidebar-item ${isActive("/admin/home/human_resources")? 'active' : ''}`}
          >
            Human Resources
          </MenuItem>
        </Menu>
      </Sidebar>
    </div>
  );
};

export default AppSidebar;


